import { serviceBackgroundChecks } from "./serviceBackgroundChecks";
import { IBackgroundCheckRequestResponse } from "@wingspanhq/background-checks/dist/lib/interfaces";

export const getBackgroundChecksRequest = async (
  requestId: string
): Promise<IBackgroundCheckRequestResponse> => {
  const { data } = await serviceBackgroundChecks.get(`/request/${requestId}`);
  return data;
};
